import { IBureauAutor, IBureauTenantResumo } from './bureaus.model';

export const BUREAU_PERMISSAO_ADMINISTRADOR = 'meurhbureaus_administrador';
export const BUREAU_PERMISSAO_TENANTS_ADMINISTRADOR = 'meurhbureaus_tenants_administrador';

export const ABA_BUREAUS = 0;
export const ABA_ADMINISTRADORES_EQUIPE = 1;
export const ABA_MEMBROS_EQUIPE = 2;

export interface IBureauEquipeVinculoAdministrador {
    bureauequipeadministrador: string;
    tenant: IBureauTenantResumo;
    created_at: string;
    created_by: IBureauAutor | null;
}

export interface IBureauEquipeVinculoMembro {
    bureauequipemembro: string;
    tenant: IBureauTenantResumo;
    created_at: string;
    created_by: IBureauAutor | null;
}

interface IBureauEquipePessoa {
    bureauusuario: string;
    contaid: number;
    nome: string;
    /** Pode vir `null` ou string vazia. */
    sobrenome: string | null;
    email: string;
    /** Data do cadastro da pessoa nos usuários de Bureau, que define a ordem da lista. */
    created_at: string;
    /** Total de pessoas da lista; vem só na primeira página. */
    full_count?: number;
}

/** Última pessoa recebida, para buscar a página seguinte. `created_at` vai como veio da API. */
export interface IBureauEquipeOffset {
    created_at: string;
    bureauusuario: string;
}

export interface IBureauEquipeAdministrador extends IBureauEquipePessoa {
    tenants: IBureauEquipeVinculoAdministrador[];
}

export interface IBureauEquipeMembro extends IBureauEquipePessoa {
    tenants: IBureauEquipeVinculoMembro[];
}
